module.exports = __webpack_public_path__ + "img/history-clock.336b8a5f.png";